import  { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { nanoid } from 'nanoid';
import './image.sass'
import { ImageInputFile } from './types';
import ImageInputDecider from './ImageInputDecider';


export interface InputImageStateFullProps extends InputImageStateFullLogicProps {
    name?: string
    onChange?: (file: ImageInputFile[]) => void
    label?: string
    emptyAfterChange?: boolean
    className?: string
    readOnly?: boolean
}

const InputImageStateFull: React.FC<InputImageStateFullProps> = ({ defaultValue, ...rest}) => {
    const { files, setFiles } = useInputImageStateFullLogic({ defaultValue })
    return (<ImageInputStateLess {...{ files, setFiles, ...rest}} />)
}

interface InputImageStateFullLogicProps {
    defaultValue?: string
}

const useInputImageStateFullLogic = ({ defaultValue }: InputImageStateFullLogicProps) => {
    const [files, setFiles] = useState<ImageInputFile[]>(defaultValue ? [{ name: defaultValue, preview: defaultValue }] : []);
    return { files, setFiles }
}

export interface InputImageStateLessProps extends InputImageStateFullProps {
    files: ImageInputFile[]
    setFiles: React.Dispatch<React.SetStateAction<ImageInputFile[]>>
}

export const ImageInputStateLess: React.FC<InputImageStateLessProps> = ({ files, setFiles, name, onChange, label, emptyAfterChange = false, className, readOnly }) => {
    const [id] = useState(nanoid())
    const { getRootProps, getInputProps } = useDropzone({
        useFsAccessApi: false,
        accept: {
            'image/*': ['.png', '.gif', '.jpeg', '.jpg']
        },
        onDrop: acceptedFiles => {
            const myAcceptedFiles = acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            }))
            setFiles([...myAcceptedFiles]);
            if (onChange) {
                onChange([...myAcceptedFiles])
                if (emptyAfterChange) {
                    setFiles([])
                }
            }
        }
    });

    useEffect(() => () => {
        files.forEach(file => URL.revokeObjectURL(file.preview));
    }, [files]);
// aqui es default i no es readonly si clickes
    const Component = ImageInputDecider({length: files.length})
    return (
        <section className={'flex items-start justify-between ' + (className||'')}>
            <aside className='block'>
                {label && <label htmlFor={readOnly ? undefined : id} className='input_field_label text-gray-3 cursor-pointer imageLabel block'>{label}</label>}
                <input id={id} name={files.length ? name : ''} title='img' {...getInputProps()} className='border-primary' />
                {!files.length &&
                    <input id={id} name={name} value='' type='hidden' />
                }
                <Component {...{onChange, getRootProps, files, setFiles, readOnly}}></Component>
            </aside>
        </section>
    );
}


export default InputImageStateFull;
